export const gender = [
    {},
    {label: 'Female', value: 'Female'},
    {label: 'Male', value: 'Male'},
    {label: 'Non-binary', value: 'Non-binary'},
    {label: 'Prefer not to say', value: 'Prefer not to say'},
]